export enum UserDetailsTabDescriptionEnum {
  BASIC = 'user.details.tab.basic',
  PERSONAL = 'user.details.tab.personal',
}
